import Big from 'big.js';

export function Debounce(func: () => void, wait: number, immediate: boolean) {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    return () => {
        const later = () => {
            timeout = undefined;
            if (!immediate) {
                func();
            }
        };
        const callNow = immediate && !timeout;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
        if (callNow) {
            func();
        }
    };
}

export function GetPathname(url: string): string {
    const e = document.createElement('div');
    e.innerHTML = `<a href="${url}">x</a>`;
    return (e.firstChild as HTMLAnchorElement).pathname;
}

export function CapitalizeFirstLetter(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function DollarFormat(n: string | number | Big, parens: boolean = false, comma: boolean = true): string {
    if (!(n instanceof Big)) {
        n = new Big(n);
    }

    const options: Intl.NumberFormatOptions = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'USD',
    };

    if (parens) {
        options.currencySign = 'accounting';
    }
    if (!comma) {
        options.useGrouping = false;
    }

    return new Intl.NumberFormat(undefined, options).format(n.toNumber());
}

export function DataToBlobURL(data: string, mime: string): string {
    const byteArrays = [];

    for (let offset = 0; offset < data.length; offset += 1024) {
        const slice = data.slice(offset, offset + 1024);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: mime });
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
}

export function DataURItoBlob(dataURI: string, mime: string): Blob {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: mime });
}

export function RemToPx(rem: number) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function PxToRem(px: number) {
    return px / parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export async function URLToBlob(url: string): Promise<Blob> {
    return fetch(url).then(resp => resp.blob());
}